var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9987 19.1981C20.919 19.2535 20.8367 19.3059 20.752 19.3553L18.0003 20.958L7.20898 14.6727V9.32113L17.9949 3.03906L20.752 4.64487C20.8491 4.70137 20.9429 4.76197 21.0334 4.82637L13.3258 9.30742V9.29645L10.2368 11.1034V12.9411L13.3258 14.7441V12.9189L22.5735 7.53274C22.5825 7.63809 22.5871 7.74435 22.5871 7.85126V11.0934L16.4291 14.6978V16.549L20.9987 19.1981Z",
    fill: "#0366C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9056 1.23987L13.6285 0.49603C12.4929 -0.165343 11.0939 -0.165343 9.95834 0.49603L2.83507 4.64482C1.69952 5.3062 1 6.52846 1 7.8512V16.1488C1 17.4715 1.69952 18.6938 2.83506 19.3552L9.95834 23.504C11.0939 24.1653 12.4929 24.1653 13.6285 23.504L14.911 22.757L4.11961 16.4718V7.52429L4.12384 7.52674L4.11961 7.52194L14.9056 1.23987Z",
    fill: "#0366C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.834a0920b7dbbfb97842cc8fb7776041.svg";
export { ForwardRef as ReactComponent };